import { Button } from "primereact/button";
import { useState } from "react";
import "./StoreNavDropdown.css";
import LanguageSelectionButton from "../LanguageSelectionButton/LanguageSelectionButton";
import localeText from "../../locale";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { locale } from "../../utilities/locale/locale";

const StoreNavDropdown = ({ categories, onSearch }) => {
  const [isOpen, setIsOpen] = useState(false);

  const topCategoriesSample = [
    {
      descriptionEnglish: "Agro and Industry",
      descriptionSpanish: "Agro y Industria",
      descriptionItalian: "Agro e Industria",
      descriptionPortuguese: "Agro e Industria",
      id: 11,
    },
    {
      descriptionEnglish: "pets",
      descriptionSpanish: "Animales de estimación",
      descriptionItalian: "Animali domestici",
      descriptionPortuguese: "Animais de estimação",
      id: 10,
    },
    {
      descriptionEnglish: "Children items",
      descriptionSpanish: "Artículos para niños",
      descriptionItalian: "Articoli per bambini",
      descriptionPortuguese: "Artigos infantis",
      id: 9,
    },
    {
      descriptionEnglish: "Auto and parts",
      descriptionSpanish: "Auto e piezas",
      descriptionItalian: "Auto e ricambi",
      descriptionPortuguese: "Autos e peças",
      id: 1,
    },
    {
      descriptionEnglish: localeText("fringeBenefits"),
      descriptionSpanish: localeText("fringeBenefits"),
      descriptionItalian: localeText("fringeBenefits"),
      descriptionPortuguese: localeText("fringeBenefits"),
      id: -1,
    },
  ];

  const handleCategoryName = (category) => {
    const descriptions = {
      en: category.descriptionEnglish,
      it: category.descriptionItalian,
      pt: category.descriptionPortuguese,
      es: category.descriptionSpanish,
    };
    return descriptions[locale] ?? "";
  };

  const handleCategorySearch = (category) => {
    if (category.id === -1) {
      window.location.href = "/fringe-benefits?search=ALL&currency=ALL&area=ALL";
      return;
    }

    onSearch("ALL", category);
  };

  return (
    <div className="relative w-64" style={{ height: "100%", marginLeft: "-16px" }}>
      <Button
        onClick={() => setIsOpen(!isOpen)}
        className="border-none border-noround outline-none p-button-no-outline "
        style={{ backgroundColor: "#39873A", height: "100%", padding: "18px" }}
      >
        <i style={{ fontSize: "24px" }} className={isOpen ? "pi pi-times" : "pi pi-bars"}></i>
      </Button>

      {isOpen && (
        <div
          style={{ backgroundColor: "#39873A", width: "100vw", borderTop: "1px solid #28AB69" }}
          className="absolute gap-4 flex flex-column align-items-left p-4 z-3"
        >
          <Link
            className="font-semibold text-white hover:underline p-0 focus:shadow-none "
            to="/categories"
            onClick={() => setIsOpen(false)}
          >
            {localeText("allDepartments")}
          </Link>
          <hr className="p-0 m-0 w-full" style={{ borderTop: "solid 1px #28AB69" }} />
          {topCategoriesSample.map((category) => (
            <div key={category.id}>
              <Button
                className="font-semibold text-white hover:underline p-0 focus:shadow-none "
                link
                onClick={() => handleCategorySearch(category)}
              >
                {handleCategoryName(category)}
              </Button>
              <hr className="p-0 m-0 w-full mt-4" style={{ borderTop: "solid 1px #28AB69" }} />
            </div>
          ))}
          <LanguageSelectionButton storePage={false} storePageDropdown={true} />
        </div>
      )}
    </div>
  );
};

export default StoreNavDropdown;
